import React from "react";
import { useTranslation } from "react-i18next";
import ItemCardInfos from "../itemCard/components/itemCardInfos/itemCardInfos";
import ItemCard from "../itemCard/itemCard";
import "./ticketCard.css";

export function TicketCard({ ticket, onSubmit }) {
    const { t } = useTranslation();

	const activeStatus = React.useMemo(() => {
        if (['active', 'free', 'paid'].includes(ticket.status)) {
            return "valid"
        }
        return ticket.status
    },[ticket])

	const name = React.useMemo(() => {
		const full_name = [ticket.first_name, ticket.last_name];
		return full_name.join(' ');
	}, [ticket])

	const actionTicket = React.useMemo(() => {
		return {
			label: t('widget.button.manage.default_label'),
			icon: "arrowRight",
			onClick: () => onSubmit({
				data: {
					action: ticket.actions[0].type,
					payload: {
						attendee_id: ticket.id
					}
				}
			})
		}
	}, [ticket, onSubmit]);

	return (
		<div className="wz-ticket-list">
			<ItemCard type={'order-card'} status={activeStatus} title={name} subtitle={ticket.rate_name} action={actionTicket}>
				<ItemCardInfos title={t('widget.information.ticket')} informations={ticket.informations} />
				{ticket.resale_status && <ItemCardInfos title={t('widget.information.resale')} informations={ticket.resale_informations} />}
			</ItemCard>
		</div>
	);
}
